import React, { FC } from 'react';
import { PictureSources } from 'features/reviews';
import { Styles as TLStyles } from 'common/components/media-gallery/tiles-line-gallery.styles';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';
import { useTranslation } from 'react-i18next';
import { Styles } from '../styles';

export const DATA_QA_TILE_CONTENT_BUTTON = 'tile-content-button';
export const DATA_QA_TILE_CONTENT_IMAGE_PLACEHOLDER = 'tile-content-image-placeholder';

type Props = {
  picture: PictureSources;
  onShowPicture: (pic: PictureSources | null) => void;
};

export const TileContent: FC<Props> = ({ picture, onShowPicture }) => {
  const { t } = useTranslation();
  const { urlThumb } = picture;
  return (
    <button
      className={Styles.showReviewPhotoBtn}
      onClick={() => onShowPicture(picture)}
      data-qa={DATA_QA_TILE_CONTENT_BUTTON}
    >
      <ImagePlaceholder
        className={TLStyles.tileImgTileContent}
        src={urlThumb}
        loading="lazy"
        alt=""
        fallbackWidth={48}
        fallbackHeight={48}
        fallbackAlt={t('ui.image.alt')}
        data-qa={DATA_QA_TILE_CONTENT_IMAGE_PLACEHOLDER}
      />
    </button>
  );
};
